import { render, staticRenderFns } from "./SDialogSearchLaboratoryComp.vue?vue&type=template&id=39ca2aae&"
import script from "./SDialogSearchLaboratoryComp.vue?vue&type=script&lang=js&"
export * from "./SDialogSearchLaboratoryComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports